import {
    GET_TITLES_FAIL,
    GET_TITLES_SUCCESS,
    ADD_TITLE_SUCCESS,
    ADD_TITLE_FAIL,
    UPDATE_TITLE_SUCCESS,
    UPDATE_TITLE_FAIL,
    DELETE_TITLE_SUCCESS,
    DELETE_TITLE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    titles: [],
    error: null,
    loading: true
};

const titleReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des titles
        case GET_TITLES_SUCCESS:
            return {
                ...state,
                titles: action.payload, // tableau d'objetstitle
                loading: false,
                error: null
            };

        case GET_TITLES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'unetitlee
        case ADD_TITLE_SUCCESS:
            return {
                ...state,
                titles: [action.payload, ...state.titles], // ajoute au début du tableau
                error: null
            };

        case ADD_TITLE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'unetitlee
        case UPDATE_TITLE_SUCCESS:
            return {
                ...state,
                titles: state.titles.map(title =>
                   title.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objettitle
                        :title
                ),
                error: null
            };

        case UPDATE_TITLE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'unetitlee
        case DELETE_TITLE_SUCCESS:
            return {
                ...state,
                titles: state.titles.filter(
                   title =>title.id !== action.payload
                ),
                error: null
            };


        case DELETE_TITLE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default titleReducer;
